import React, { useState } from 'react';
import {
	MailContainer,
	StyledTable,
	Line,
	Label,
	Value,
	Textarea,
	ValueWrapper,
	Buttonwrapper,
	EmailResp,
} from './TestMail.styles';
import { ApButtonSecondary, ApInput } from '@alixpartners/ui-components';
import { LINK_TYPES } from '../utils';
import { sendMailtoSpendOwners } from 'utils/apiRequests';

const TestMail = props => {
	const [testMail, setTestMail] = useState({ id: '', message: '' });
	const [mailResponse, setMailResponse] = useState('');
	const { location } = props;

	const handleChange = (change, changeContent) => {
		if (change === 'ownerId') {
			setTestMail(prevState => ({
				...prevState,
				id: changeContent,
			}));
		} else {
			setTestMail(prevState => ({ ...prevState, message: changeContent }));
		}
	};

	const handleEmailSend = (loc, credentials) => {
		const link = loc.pathname.split('/');

		const payload = {
			type: 1,
			message: credentials.message,
			linkNumber: LINK_TYPES[link[2]].toString(),
			email: credentials.id,
		};

		sendMailtoSpendOwners(payload).then(response => {
			setTestMail({ id: '', message: '' });
			if (response.succeeded) {
				setMailResponse('Email sent successfully');
			} else {
				setMailResponse('Error occured.Try Again');
			}
			setTimeout(
				() => {
					setMailResponse('');
				},
				[4000]
			);
		});
	};

	return (
		<MailContainer>
			<StyledTable>
				<Line>
					<Label>Email</Label>
					<Value>
						<ValueWrapper>
							<ApInput
								value={testMail.id}
								type="text"
								name={'ownerId'}
								onChange={event => handleChange('ownerId', event)}
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Message</Label>
					<Value>
						<>
							<Textarea
								rows={5}
								value={testMail.message}
								onChange={event =>
									handleChange('ownerMessage', event.target.value)
								}
							/>
						</>
					</Value>
				</Line>
			</StyledTable>
			<Buttonwrapper>
				<ApButtonSecondary
					onClick={() => handleEmailSend(location, testMail)}
					disabled={testMail.id === '' || testMail === ''}
				>
					Send Email
				</ApButtonSecondary>
				<EmailResp>{mailResponse}</EmailResp>
			</Buttonwrapper>
		</MailContainer>
	);
};

export default TestMail;
